export const branchNameLocalizations = {
  2: $localize`Hanover`,
  3: $localize`Mt Forest`,
  4: $localize`Kincardine`,
  5: $localize`Goderich`,
  6: $localize`Owen Sound`,
  7: $localize`Wingham`,
  8: $localize`Orillia`,
  9: $localize`Midland`,
  10: $localize`Mitchell`,
  11: $localize`Orangeville`,
  12: $localize`Barrie`,
  14: $localize`Stratford`,
  15: $localize`Parry Automotive`,
  17: $localize`Listowel`,
  18: $localize`Collingwood`,
  23: $localize`Listowel Machine Shop`,
  27: $localize`Harriston`,
  28: $localize`Exeter`,
  29: $localize`Walkerton`,
  30: $localize`Shelburne`,
  31: $localize`Alliston`,
  32: $localize`Port Elgin`,
  33: $localize`Woodstock`,
  34: $localize`St Marys`,
  35: $localize`Haliburton`,
  36: $localize`Huntsville`,
  37: $localize`Parry Sound`,
  38: $localize`Keswick`,
  39: $localize`Windsor`,
  40: $localize`Leamington`,
  41: $localize`Flesherton`,
  42: $localize`New Hamburg`,
  43: $localize`Barrie South`,
  45: $localize`Bracebridge`,
  47: $localize`Daltco Kingston`,
  48: $localize`Daltco Brockville`,
  49: $localize`Daltco Ottawa`,
  50: $localize`Ridgetown`,
  51: $localize`Chatham`,
  52: $localize`Wallaceburg`,
  88: $localize`Warehouse`,
  98: $localize`Wire Warehouse`,
} as const;
